<template>
  <div>
    <div class="detail-content">
      <div class="top">
        <div class="position-name">{{positionItemData.positionName}}</div>
        <div class="row-item">
          <div class="col-item">
            <label for>工作地点：</label>
            <span>{{positionItemData.workPlace}}</span>
          </div>
          <div class="col-item">
            <label for>所属公司：</label>
            <span>{{positionItemData.company}}</span>
          </div>
        </div>
        <div class="row-item">
          <div class="col-item">
            <label for>薪资：</label>
            <span>{{positionItemData.salary}}</span>
          </div>
          <div class="col-item">
            <label for>招聘人数：</label>
            <span>{{positionItemData.count}}</span>
          </div>
        </div>
      </div>
      <div class="position-footer">
        <!-- 职位描述 -->
        <div class="position">
          <div class="position-title">职位描述</div>
          <div
            class="desc-item"
            v-for="(item , index) in positionItemData.descList"
            :key="index"
          >{{item}}</div>
        </div>
        <!-- 任职要求 -->
        <div class="position" style="margin-top:20px">
          <div class="position-title">任职要求</div>
          <div
            class="desc-item"
            v-for="(item , index) in positionItemData.recommendList"
            :key="index"
          >{{item}}</div>
        </div>
        <!-- 薪酬待遇 -->
        <div class="position" style="margin-top:20px">
          <div class="position-title">薪酬待遇</div>
          <div
            class="desc-item"
            v-for="(item , index) in positionItemData.treatmentList"
            :key="index"
          >{{item}}</div>
        </div>
        <!-- 福利 -->
        <div class="position" style="margin-top:20px">
          <div class="position-title">福利</div>
          <div
            class="desc-item"
            v-for="(item , index) in positionItemData.welfareList"
            :key="index"
          >{{item}}</div>
        </div>
        <div class="btn" @click="consult">咨询职位</div>
      </div>
    </div>
    <!-- 微信二维码 -->
    <Modal v-model="showQrcode" width="232">
      <div slot="header"></div>
      <div slot="close"></div>
      <div class="qrcode">
        <img src="@/assets/images/qrcode.png" alt="微信二维码" />
      </div>
      <p>关注微信</p>
      <p>咨询最新职位信息</p>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
export default {
  props: {
    positionId: {
      type: Number,
      require: true,
    },
  },
  data() {
    return {
      showQrcode: false,
      positionItemData: {},
    };
  },
  methods: {
    consult() {
      this.showQrcode = true;
    },
  },
};
</script>

<style lang="less" scoped>
.detail-content {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.top,
.position-footer {
  width: 100%;
  border: 1px solid #b9babc;
  padding: 20px;
  box-sizing: border-box;
}
.position-footer {
  margin-top: 20px;

  .btn {
    width: 200px;
    height: 40px;
    background-color: #2d8cf0;
    color: #fff;
    text-align: center;
    line-height: 40px;
    margin: 30px auto 0px;
    border-radius: 6px;
    font-size: 16px;
  }
  .btn:hover {
    cursor: pointer;
  }
}
.position-name {
  height: 50px;
  font-size: 20px;
  font-weight: 700;
}
.row-item {
  display: flex;
  padding: 5px 0 5px;
  .col-item {
    flex: 1;
  }
}
.position {
  width: 100%;
  .position-title {
    height: 35px;
    line-height: 35px;
    font-size: 15px;
    color: #2d8cf0;
  }
  .desc-item {
    margin-top: 5px;
  }
}
.qrcode {
  width: 200px;
  img {
    width: 100%;
  }
}
p {
  text-align: center;
  color: #666;
}
</style>